import AdaptiveCardsStyleOptions, { StrictAdaptiveCardsStyleOptions } from '/druid/AdaptiveCardsStyleOptions';
import defaultStyleOptions from '/druid/defaultStyleOptions';

export default function normalizeStyleOptions(
  styleOptions: AdaptiveCardsStyleOptions
): StrictAdaptiveCardsStyleOptions {
  return { ...defaultStyleOptions, ...styleOptions };
}
